<template>
  <div>
    <b-row>
      <b-col md="6">
        <validation-provider
          :name="name + '_Nome'"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-form-group label="Nome" label-for="Nome">
            <b-form-input
              :name="name + '_name'"
              v-model="value.name"
              :state="validateState(validationContext)"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col md="6">
        <validation-provider
          :name="name + '_DataNascimento'"
          :rules="{ required: true }"
          v-slot="{ classes }"
        >
          <b-form-group
            label="Data de nascimento"
            label-for="birthdate"
            :class="classes"
          >
            <datepicker
              v-model="value.birthdate"
              format="dd/MM/yyyy"
              initial-view="year"
              minimum-view="decade"
              :typeable="true"
              name="datepicker"
              :input-class="dateClasses(classes)"
              required
              :disabled-dates="disabledDates"
            >
            </datepicker>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Base from "./base";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

import Datepicker from "vuejs-datepicker";

export default {
  name: "ParentsData",
  extends: Base,
  components: { Datepicker },
  data() {
    return {
      disabledDates: {}
    }
  },
  methods: {
    dateClasses(classes) {
      return Object.assign({ "form-control": true }, classes);
    },
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    name,
  },
  created() {
    let today = new Date()
    var currentYear = (new Date()).getFullYear() 
    let minus100 = new Date(currentYear - 80, 0,1)
    this.disabledDates = {         
          to: minus100, // Disable all dates up to specific date
          from: today, // Disable all dates after specific date         
      }
    
  }
};
</script>
